module.exports = __webpack_public_path__ + "static/media/3 03 Tulleord Na er det din tur.ad390d7f.mp3";